import { navLinks } from '@/mocks/homeData';

const keywordLinks = [
  '善良的女秘书中文字幕',
  '善良的女秘书字幕在线',
  '善良的女秘书中文版',
  '善良的女秘书国语版',
  '善良的女秘书中字',
  '善良的女秘书字幕组',
];

export default function SiteFooter() {
  const toTop = () => {
    const el = document.getElementById('top');
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <footer className="w-full bg-primary-900 text-background-100">
      <div className="mx-auto w-full max-w-[1240px] px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-3">
          <div>
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-accent-500 text-foreground-950">
                <i className="ri-book-2-line text-lg" aria-hidden="true"></i>
              </span>
              <span className="font-heading text-lg font-bold text-background-50">善良的女秘书</span>
            </div>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-background-200/80">
              本站聚焦《善良的女秘书》的中文字幕与译制版本，整理中文版、国语版、中文字幕、
              字幕在线、中字与字幕组相关信息，帮助你在一个页面内选对版本、看懂情节。
            </p>
          </div>

          <div>
            <h3 className="font-heading text-sm font-bold text-background-50">页面分区</h3>
            <ul className="mt-4 space-y-2.5">
              {navLinks.map((link) => (
                <li key={link.id}>
                  <a
                    href={`#${link.id}`}
                    className="cursor-pointer text-sm text-background-200/85 transition-colors hover:text-accent-300"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-sm font-bold text-background-50">相关主题</h3>
            <ul className="mt-4 flex flex-wrap gap-2">
              {keywordLinks.map((word) => (
                <li key={word}>
                  <span className="inline-block rounded-full bg-background-50/10 px-3 py-1 text-xs text-background-200/85">
                    {word}
                  </span>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-12 flex flex-col items-start justify-between gap-4 border-t border-background-50/15 pt-6 sm:flex-row sm:items-center">
          <p className="text-xs text-background-200/70">
            本页为影视字幕与译制版本的主题信息整理，内容将持续更新。
          </p>
          <button
            type="button"
            onClick={toTop}
            className="inline-flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-md border border-background-50/25 px-4 py-2 font-label text-xs text-background-100 transition-colors hover:bg-background-50/10"
          >
            <i className="ri-arrow-up-line text-sm" aria-hidden="true"></i>
            回到顶部
          </button>
        </div>
      </div>
    </footer>
  );
}